export default __webpack_public_path__ + "static/media/horde.8e79f08f.jpg";